import { GWElement } from 'lib/elements'

const PROFILE_IDENTIFIER_KEYS = ['id', 'email', 'phoneNumber']

export class EmailSubscriptionBanner extends GWElement {
  constructor() {
    super()

    this.profileForm = document.querySelector('email-preferences-form')
    this.subscriptionToggle = this.querySelector('[data-subscription-toggle]')

    this.addListener(this.subscriptionToggle, 'click', this.toggleSubscription)
  }

  get optionDefaults() {
    return {
      state: 'subscribed',
      submitting: false,
    }
  }

  get state() {
    return this.options.state
  }

  set state(value) {
    this.profile.subscribed = value === 'subscribed'
    this.params?.set('subscribed', this.profile.subscribed)
    this.setAttribute('state', value)
  }

  get inverseState() {
    return this.stateKey(!this.profile.subscribed)
  }

  set submitting(value) {
    this.subscriptionToggle.disabled = value
    this.setAttribute('submitting', value)
  }

  get submitting() {
    return this.options.submitting
  }

  static get observedAttributes() {
    return ['state', 'submitting']
  }

  async getProfile() {
    if (this.profileForm) {
      await this.getProfileFromForm()
    } else {
      await this.getProfileFromParams()
    }

    return this.profile
  }

  async getProfileFromForm() {
    this.profile = await this.profileForm.shareProfile()

    return this.profile
  }

  async getProfileFromParams() {
    this.params = new URLSearchParams(window.location.search)
    this.profile = PROFILE_IDENTIFIER_KEYS.reduce((profile, key) => ({ ...profile, [key]: this.params.get(key) }), {})
    this.profile.subscribed = !this.params.has('subscribed') || this.params.get('subscribed') !== 'false'

    return this.profile
  }

  stateKey(subscribed = this.profile?.subscribed) {
    return !subscribed ? 'unsubscribed' : 'subscribed'
  }

  async update() {
    await this.getProfile()
    this.state = this.stateKey()
  }

  async init() {
    super.init()

    this.update()
  }

  async toggleSubscription(event) {
    event.preventDefault()

    this.submitting = true

    try {
      await this.getProfile()
      const shop = Shopify.shop.replace('.myshopify.com', '')
      const identifiers = { id: this.profile.id, email: this.profile.email }
      const subscribe = !this.profile.subscribed

      const body = { subscribe, identifiers, shop }
      const url = '/tools/api/klaviyo/subscription'

      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      })

      await response.json()

      this.state = this.inverseState
    } catch (error) {
      console.error('Error updating subscription status', error)
    } finally {
      this.submitting = false
    }
  }
}

if (!customElements.get('email-subscription-banner')) {
  customElements.define('email-subscription-banner', EmailSubscriptionBanner)
}
